module.exports = __webpack_public_path__ + "static/vwhead-extrabold-18fdbdad42fe7a6d0d35e75067e80435.woff2";